
export default {
  // Navigation-related translations
  "home": "Inicio",
  "profile": "Perfil",
  "airports": "Aeropuertos",
  "inventory": "Inventario",
  "admin": "Administrador",
  "resources": "Recursos",
  "develop": "Revelar",
  "sign_in": "Iniciar Sesión",
  "sign_up": "Registrarse",
  // "light_meter": "Fotómetro" // Commented out to hide from navigation
};
